import ptFlag from "@/assets/flags/pt.svg";
import esFlag from "@/assets/flags/es.svg";
import frFlag from "@/assets/flags/fr.svg";
import grFlag from "@/assets/flags/gr.svg";
import mxFlag from "@/assets/flags/mx.svg";
import crFlag from "@/assets/flags/cr.svg";
import paFlag from "@/assets/flags/pa.svg";
import thFlag from "@/assets/flags/th.svg";
import myFlag from "@/assets/flags/my.svg";
import ecFlag from "@/assets/flags/ec.svg";
import coFlag from "@/assets/flags/co.svg";
import vnFlag from "@/assets/flags/vn.svg";
import deFlag from "@/assets/flags/de.svg";
import caFlag from "@/assets/flags/ca.svg";
import nlFlag from "@/assets/flags/nl.svg";
import nzFlag from "@/assets/flags/nz.svg";
import auFlag from "@/assets/flags/au.svg";
import jpFlag from "@/assets/flags/jp.svg";
import sgFlag from "@/assets/flags/sg.svg";
import itFlag from "@/assets/flags/it.svg";
import hrFlag from "@/assets/flags/hr.svg";
import uyFlag from "@/assets/flags/uy.svg";
import arFlag from "@/assets/flags/ar.svg";
import clFlag from "@/assets/flags/cl.svg";

const flagByCode = {
  PT: ptFlag,
  ES: esFlag,
  FR: frFlag,
  GR: grFlag,
  MX: mxFlag,
  CR: crFlag,
  PA: paFlag,
  TH: thFlag,
  MY: myFlag,
  EC: ecFlag,
  CO: coFlag,
  VN: vnFlag,
  DE: deFlag,
  CA: caFlag,
  NL: nlFlag,
  NZ: nzFlag,
  AU: auFlag,
  JP: jpFlag,
  SG: sgFlag,
  IT: itFlag,
  HR: hrFlag,
  UY: uyFlag,
  AR: arFlag,
  CL: clFlag,
};

const codeByName = {
  Portugal: "PT",
  Spain: "ES",
  France: "FR",
  Greece: "GR",
  Mexico: "MX",
  "Costa Rica": "CR",
  Panama: "PA",
  Thailand: "TH",
  Malaysia: "MY",
  Ecuador: "EC",
  Colombia: "CO",
  Vietnam: "VN",
  Germany: "DE",
  Canada: "CA",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Australia: "AU",
  Japan: "JP",
  Singapore: "SG",
  Italy: "IT",
  Croatia: "HR",
  Uruguay: "UY",
  Argentina: "AR",
  Chile: "CL",
};

export const getCountryFlagCode = (code, name) => {
  if (code && flagByCode[code]) return code;
  if (name && codeByName[name]) return codeByName[name];
  return null;
};

export const getCountryFlagSrc = (code, name) => {
  const resolvedCode = getCountryFlagCode(code, name);
  return resolvedCode ? flagByCode[resolvedCode] : null;
};
